module.exports = __webpack_public_path__ + "img/logo.07e7e9e3.png";